<section class="ac-home-hero">
  <div class="ac-home-hero__copy">
    <p class="ac-kicker">{{ content.hero.kicker }}</p>
    <h1 class="ac-home-hero__title">{{ content.hero.title }}</h1>
    <p class="ac-home-hero__lead">{{ content.hero.lead }}</p>
    <div class="ac-home-hero__actions">
      <a
        class="ac-btn ac-btn--amber ac-btn--lg"
        [routerLink]="content.hero.primaryCta.route"
      >
        {{ content.hero.primaryCta.label }}
      </a>
      <a
        class="ac-btn ac-btn--ghost-light ac-btn--lg"
        [routerLink]="content.hero.secondaryCta.route"
      >
        {{ content.hero.secondaryCta.label }}
      </a>
    </div>
  </div>
  <div class="ac-home-hero__visual">
    <img
      [src]="content.hero.photo.src"
      [alt]="content.hero.photo.alt"
      [style.object-position]="content.hero.photo.objectPosition ?? 'center'"
      width="900"
      height="700"
      sizes="(min-width: 900px) 50vw, 100vw"
      loading="eager"
      fetchpriority="high"
      decoding="sync"
    />
    <div class="ac-home-hero__overlay" aria-hidden="true"></div>
  </div>
</section>

<section class="ac-section ac-home-context">
  <div class="ac-container ac-home-context__grid">
    <div>
      <h2 class="ac-section-title">{{ content.context.title }}</h2>
      <p class="ac-lead">{{ content.context.lead }}</p>
      <p class="ac-home-context__body">{{ content.context.body }}</p>
    </div>
    <div class="ac-home-context__photo">
      <img
        [src]="content.context.photo.src"
        [alt]="content.context.photo.alt"
        [style.object-position]="content.context.photo.objectPosition ?? 'center'"
        width="600"
        height="450"
        loading="lazy"
      />
    </div>
  </div>
</section>

<section class="ac-section ac-home-modules-section">
  <div class="ac-container">
    <h2 class="ac-section-title ac-section-title--center">
      {{ content.modulesSection.title }}
    </h2>
    <p class="ac-home-modules__lead ac-section-title--center">
      {{ content.modulesSection.lead }}
    </p>
    <div class="ac-home-modules">
      @for (mod of content.modules; track mod.id) {
      <a class="ac-module-card ac-module-card--link" [routerLink]="mod.route">
        <div class="ac-module-card__photo">
          <ac-photo-carousel [photos]="mod.photos" />
        </div>
        <div class="ac-module-card__body">
          <p class="ac-kicker">{{ mod.kicker }}</p>
          <div
            class="ac-module-card__icon ac-module-card__icon--{{ mod.accent }}"
          >
            <fa-icon [icon]="['fas', mod.icon]"></fa-icon>
          </div>
          <h3 class="ac-module-card__title">{{ mod.name }}</h3>
          <p class="ac-module-card__blurb">{{ mod.blurb }}</p>
          <span class="ac-module-card__link">
            Open module
            <fa-icon [icon]="['fas', 'arrow-right']"></fa-icon>
          </span>
        </div>
      </a>
      }
    </div>
  </div>
</section>

<section class="ac-section ac-home-steps-section" id="how-it-works">
  <div class="ac-container">
    <div class="ac-home-steps__header">
      <h2 class="ac-section-title ac-section-title--center">
        {{ content.howItWorks.title }}
      </h2>
      <p class="ac-lead ac-home-steps__lead">{{ content.howItWorks.lead }}</p>
      <p class="ac-home-steps__intro">{{ content.howItWorks.intro }}</p>
      <p class="ac-home-steps__intro">{{ content.howItWorks.closing }}</p>
    </div>

    <div class="ac-home-steps__layout">
      <div class="ac-home-steps">
        @for (step of content.howItWorks.steps; track step.title) {
        <article class="ac-step">
          <div class="ac-step__icon">
            <fa-icon [icon]="['fas', step.icon]"></fa-icon>
          </div>
          <h3 class="ac-step__title">{{ step.title }}</h3>
          <p class="ac-step__body">{{ step.body }}</p>
        </article>
        }
      </div>

      <div class="ac-home-steps__photo">
        <img
          [src]="content.howItWorks.photo.src"
          [alt]="content.howItWorks.photo.alt"
          [style.object-position]="content.howItWorks.photo.objectPosition ?? 'center'"
          width="640"
          height="480"
          loading="lazy"
        />
      </div>
    </div>
  </div>
</section>

<section class="ac-section ac-home-technology">
  <div class="ac-container ac-home-technology__layout">
    <div class="ac-home-technology__photo">
      <img
        [src]="content.technology.photo.src"
        [alt]="content.technology.photo.alt"
        [style.object-position]="content.technology.photo.objectPosition ?? 'center'"
        width="640"
        height="480"
        loading="lazy"
      />
    </div>
    <div>
      <h2 class="ac-section-title">{{ content.technology.title }}</h2>
      <div class="ac-home-technology__grid">
        @for (item of content.technology.items; track item.title) {
        <article class="ac-home-technology__card">
          <div class="ac-home-technology__icon">
            <fa-icon [icon]="['fas', item.icon]"></fa-icon>
          </div>
          <h3 class="ac-home-technology__title">{{ item.title }}</h3>
          <p class="ac-home-technology__body">{{ item.body }}</p>
        </article>
        }
      </div>
    </div>
  </div>
</section>

<section class="ac-section ac-home-integrated">
  <div class="ac-container">
    <h2 class="ac-section-title ac-section-title--center">
      {{ content.integratedModules.title }}
    </h2>
    <p class="ac-lead ac-home-integrated__lead">
      {{ content.integratedModules.lead }}
    </p>
    <div class="ac-home-integrated__grid">
      @for (mod of content.integratedModules.items; track mod.id) {
      <a
        class="ac-integrated-card ac-integrated-card--{{ mod.accent }}"
        [routerLink]="mod.route"
      >
        <div class="ac-integrated-card__photo">
          <ac-photo-carousel [photos]="mod.photos" />
        </div>
        <div class="ac-integrated-card__body">
          <div class="ac-integrated-card__icon">
            <fa-icon [icon]="['fas', mod.icon]"></fa-icon>
          </div>
          <h3 class="ac-integrated-card__title">{{ mod.title }}</h3>
          <p class="ac-integrated-card__body-text">{{ mod.body }}</p>
          <span class="ac-integrated-card__cta">
            Learn more
            <fa-icon [icon]="['fas', 'arrow-right']"></fa-icon>
          </span>
        </div>
      </a>
      }
    </div>
  </div>
</section>

<section class="ac-section ac-home-cta">
  <div class="ac-container ac-home-cta__inner">
    <div>
      <h2 class="ac-section-title">{{ content.closingCta.title }}</h2>
      <p class="ac-home-cta__lead">{{ content.closingCta.body }}</p>
      <div class="ac-stack-badges ac-home-cta__stack">
        @for (item of content.stack.items; track item.label) {
        <a
          class="ac-stack-badge"
          [href]="item.href"
          target="_blank"
          rel="noopener noreferrer"
          >{{ item.label }}</a
        >
        }
      </div>
    </div>
    <div class="ac-home-cta__actions">
      <a
        class="ac-btn ac-btn--amber ac-btn--lg"
        [routerLink]="content.closingCta.primary.route"
      >
        {{ content.closingCta.primary.label }}
      </a>
      <a
        class="ac-btn ac-btn--ghost-light ac-btn--lg"
        [routerLink]="content.closingCta.secondary.route"
      >
        {{ content.closingCta.secondary.label }}
      </a>
    </div>
  </div>
</section>
